// ##############################
// // // Lightbox component styles
// #############################

const lightboxStyle = {
    paper: {
        overflowY: 'visible',
    },
    content: {
        overflowY: 'visible' ,
    },
    title: {
        color: '#333333',
        fontWeight: 'bold',
        fontSize: 36,
        textTransform: 'uppercase',
    },
    clearButton: {
        float: 'right',
    },
};

export default lightboxStyle;



// WEBPACK FOOTER //
// ./src/common/Lightbox/styles.jsx